import CanvasRenderer from "./canvas-renderer";
const DEFAULT_CROP = [0, 0, 0, 0];
export default class SlideRenderer extends CanvasRenderer {
    performRendering(data, timestamp) {
        return this.renderSlides(data, timestamp);
    }
    saveReturnData(data) {
        return data.returnData;
    }
}
